"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var customer_1 = require("../../../api/customer");
var reactstrap_1 = require("reactstrap");
var CustomerEditForm = react_1.forwardRef(function (props, ref) {
    var _a = react_1.useState({
        id: props.data.id,
        name: props.data.name,
        displayName: props.data.displayName,
        email: props.data.email,
        phoneNumber: props.data.phoneNumber,
        status: props.data.status,
        address: { firstLine: props.data.address.firstLine, secondLine: props.data.address.secondLine, state: props.data.address.state, country: props.data.country },
        industry: props.data.industry,
        description: props.data.description,
        language: props.data.language,
        country: props.data.country,
        createdAt: props.data.createdAt,
        modifiedAt: props.data.modifiedAt,
        profilepic: props.data.profilepic
    }), data = _a[0], setData = _a[1];
    react_1.useImperativeHandle(ref, function () { return ({
        submitForm: function () {
            var obj = {
                id: data.id,
                name: data.name,
                displayName: data.displayName,
                email: data.email,
                phoneNumber: data.phoneNumber,
                status: data.status,
                industry: data.industry,
                description: data.description,
                address: data.address,
                modifiedAt: props.data.modifiedAt,
            };
            customer_1.updateCustomer(data.id, obj).then(function (response) {
                props.modalCallback();
            });
        }
    }); });
    var onLoad = function () {
        if (data.id == null || data.id == 0) {
            setData({
                id: props.data.id,
                name: props.data.name,
                displayName: props.data.displayName,
                email: props.data.email,
                phoneNumber: props.data.phoneNumber,
                status: props.data.status,
                address: { firstLine: props.data.address.firstLine, secondLine: props.data.address.secondLine, state: props.data.address.state, country: props.data.country },
                industry: props.data.industry,
                description: props.data.description,
                language: props.data.language,
                country: props.data.country,
                createdAt: props.data.createdAt,
                modifiedAt: props.data.modifiedAt,
                profilepic: props.data.profilepic
            });
        }
    };
    var setFormChange = function (e, field) {
        var newData = data;
        if (field.includes('address.')) {
            field = field.replace('address.', '');
            var address = newData.address || {};
            address[field] = e.target.value;
            newData.address = address;
        }
        else {
            newData[field] = e.target.value;
        }
        console.log(newData[field]);
        setData(__assign({}, newData));
    };
    react_1.useEffect(function () {
        onLoad();
    }, [data, setData]);
    return data.id == null || data.id == 0 ? (React.createElement(React.Fragment, null, "Loading...")) : (React.createElement(reactstrap_1.Form, null,
        React.createElement(reactstrap_1.Row, { form: true },
            React.createElement(reactstrap_1.Col, { md: 12 },
                React.createElement("h5", null, "Company")),
            React.createElement(reactstrap_1.Col, { md: 6 },
                React.createElement(reactstrap_1.FormGroup, null,
                    React.createElement(reactstrap_1.Label, { for: "Name" }, "Name"),
                    React.createElement(reactstrap_1.Input, { type: "text", name: "name", id: "name", placeholder: data.name, value: data.name, onChange: function (e) { return setFormChange(e, 'name'); } })),
                React.createElement(reactstrap_1.FormGroup, null,
                    React.createElement(reactstrap_1.Label, { for: "EmailUsername" }, "Email/Username"),
                    React.createElement(reactstrap_1.Input, { type: "email", name: "EmailUsername", id: "EmailUsername", placeholder: data.email, value: data.email, onChange: function (e) { return setFormChange(e, 'email'); } })),
                React.createElement(reactstrap_1.FormGroup, null,
                    React.createElement(reactstrap_1.Label, { for: "Status" }, "Status"),
                    React.createElement(reactstrap_1.Input, { type: "select", name: "Status", id: "Status", value: data.status, onChange: function (e) { return setFormChange(e, 'status'); } },
                        React.createElement("option", null, "Inactive"),
                        React.createElement("option", null, "Active"),
                        React.createElement("option", null, "Disable")))),
            React.createElement(reactstrap_1.Col, { md: 6 },
                React.createElement(reactstrap_1.FormGroup, null,
                    React.createElement(reactstrap_1.Label, { for: "DisplayName" }, "Display Name"),
                    React.createElement(reactstrap_1.Input, { type: "text", name: "DisplayName", id: "DisplayName", placeholder: data.displayName, value: data.displayName, onChange: function (e) { return setFormChange(e, 'displayName'); } })),
                React.createElement(reactstrap_1.FormGroup, null,
                    React.createElement(reactstrap_1.Label, { for: "PhoneNumber" }, "Phone Number"),
                    React.createElement(reactstrap_1.Input, { type: "text", name: "PhoneNumber", id: "PhoneNumber", placeholder: data.phoneNumber, value: data.phoneNumber, onChange: function (e) { return setFormChange(e, 'phoneNumber'); } })),
                React.createElement(reactstrap_1.FormGroup, null,
                    React.createElement(reactstrap_1.Label, { for: "Industry" }, "Industry"),
                    React.createElement(reactstrap_1.Input, { type: "text", name: "Industry", id: "Industry", placeholder: data.industry, value: data.industry, onChange: function (e) { return setFormChange(e, 'industry'); } })))),
        React.createElement(reactstrap_1.FormGroup, null,
            React.createElement(reactstrap_1.Label, { for: "Discription" }, "Discription"),
            React.createElement(reactstrap_1.Input, { type: "text", name: "Discription", id: "Discription", placeholder: data.description, value: data.description, onChange: function (e) { return setFormChange(e, 'description'); } })),
        React.createElement(reactstrap_1.Row, { form: true },
            React.createElement(reactstrap_1.Col, { md: 12 },
                React.createElement("h5", null, "Address")),
            React.createElement(reactstrap_1.Col, { md: 6 },
                React.createElement(reactstrap_1.FormGroup, null,
                    React.createElement(reactstrap_1.Label, { for: "Address1" }, "Address 1"),
                    React.createElement(reactstrap_1.Input, { type: "text", name: "Address1", id: "Address1", placeholder: data.address != null && data.address.firstLine != null ? data.address.firstLine : "Address First Line", value: data.address != null && data.address.firstLine != null ? data.address.firstLine : "", onChange: function (e) { return setFormChange(e, 'address.firstLine'); } })),
                React.createElement(reactstrap_1.FormGroup, null,
                    React.createElement(reactstrap_1.Label, { for: "State" }, "State"),
                    React.createElement(reactstrap_1.Input, { type: "text", name: "State", id: "State", placeholder: data.address != null && data.address.state != null ? data.address.state : "State not inserted", value: data.address != null && data.address.state != null ? data.address.state : "", onChange: function (e) { return setFormChange(e, 'address.state'); } }))),
            React.createElement(reactstrap_1.Col, { md: 6 },
                React.createElement(reactstrap_1.FormGroup, null,
                    React.createElement(reactstrap_1.Label, { for: "Address2" }, "Address 2"),
                    React.createElement(reactstrap_1.Input, { type: "text", name: "Address2", id: "Address2", placeholder: data.address != null && data.address.secondLine != null ? data.address.secondLine : "Address Second Line", value: data.address != null && data.address.secondLine != null ? data.address.secondLine : "", onChange: function (e) { return setFormChange(e, 'address.secondLine'); } })),
                React.createElement(reactstrap_1.FormGroup, null,
                    React.createElement(reactstrap_1.Label, { for: "Country" }, "Country"),
                    React.createElement(reactstrap_1.Input, { type: "select", name: "Country", id: "Country", value: data.country, onChange: function (e) { return setFormChange(e, 'address.country'); } },
                        React.createElement("option", null, "Malaysia"),
                        React.createElement("option", null, "Indonesia"),
                        React.createElement("option", null, "Thailand")))))));
});
exports.default = CustomerEditForm;
//# sourceMappingURL=CustomerEditForm.js.map